<template>
  <v-container id="clientes" class="py-15">
    <TitleWidget>Clientes</TitleWidget>
    <CarouselWidget
      v-if="items && items.length"
      class="carousel-clientes"
      :items="items"
      :itemsToShow="{
        xs: 2,
        sm: 3,
        md: 4,
        lg: 5,
        xl: 5,
      }"
      :gap="20"
      nav
    >
      <template #item="{ item }">
        <v-sheet elevation="2" class="py-5 px-5 my-5 rounded-lg">
          <img class="img-logo" :src="files + item.path + '?resize=1&h=100'" />
        </v-sheet>
      </template>
    </CarouselWidget>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";

export default {
  computed: {
    items() {
      return this.$rest("clientes").item.logos?.list;
    },
  },
  beforeCreate() {
    this.$rest("clientes").get({
      save: (state, data) => {
        state.item = data;
      },
    });
  },
  components: {
    TitleWidget,
    CarouselWidget,
  },
};
</script>

<style scoped>
.img-logo {
  max-width: 100%;
  height: 80px;
  display: block;
  margin: auto;
  object-fit: contain;
}
</style>
